import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";
import { themeLight } from "./color";
import { breakpoints } from "./breakpoints";

const config = defineConfig({
  theme: {
    tokens: {
      colors: themeLight,
    },
    breakpoints,
  },
});

export const system = createSystem(defaultConfig, config);
